import { BookOpenTextIcon } from "@phosphor-icons/react/dist/csr/BookOpenText";
import { CommandItem, CommandShortcut } from "@volca/ui/components/ui/command";
import { getHelpTopicPath } from "@/help/routes";

export const HelpGuideItem = ({
  id,
  title,
  path,
  query,
  onGo,
}: {
  id: string;
  title: string;
  path: string;
  query: string;
  onGo: (to: string) => void;
}) => (
  <CommandItem
    value={`help ${id} ${query}`}
    keywords={[query, title, path]}
    onSelect={() => onGo(getHelpTopicPath(id))}
  >
    <BookOpenTextIcon />
    <span className="min-w-0 truncate">{title}</span>
    {path && (
      <CommandShortcut className="truncate font-sans tracking-normal">
        {path}
      </CommandShortcut>
    )}
  </CommandItem>
);
